import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	width: 100%;
	flex-wrap: wrap;
	justify-content: center;
	transition: all 500ms ease-in;
`;
